module.exports = __webpack_public_path__ + "static/media/theflightpost.04d06398.png";